import { useContext } from 'react'

import { LanguageContext, LanguageContextProps } from '@/contexts/Language'

const useLanguage = (): LanguageContextProps => {
  return useContext(LanguageContext)
}

export default useLanguage
